
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.12 18.6h-1.08V3.84a.36.36 0 00-.36-.36h-3.36a.36.36 0 00-.36.36V18.6h-1.92V9.36a.36.36 0 00-.36-.36h-3.36a.36.36 0 00-.36.36v9.24H8.04v-3.96a.36.36 0 00-.36-.36H4.32a.36.36 0 00-.36.36v3.96H2.88a.36.36 0 100 .72h18.24a.36.36 0 100-.72zM16.68 4.2h2.64v14.4h-2.64V4.2zm-6 5.52h2.64v8.88h-2.64V9.72zm-6 5.28h2.64v3.6H4.68V15zM3.12 11.88a.36.36 0 00.254-.106L13.32 1.83V3.36a.36.36 0 00.72 0V.96a.356.356 0 00-.223-.329A.358.358 0 0013.68.6h-2.4a.36.36 0 000 .72h1.531l-9.945 9.946a.36.36 0 00.254.614z","fill":"#fff"}})])
          )
        }
      }
    